var $ = jQuery,
	el = $('.hero-dropdown-jump-menu');

function onDocumentReady() {
	if (el.length > 0) {
		jumpMenu();
	}
}

function jumpMenu() {
	$('.hero-dropdown-menu-item').click(function() {
		let thisVal = $(this).text(),
			thisLink = $(this).attr('data-url');

		$('.hero-dropdown-filter-placeholder').html(thisVal);
		$('.hero-dropdown-filter-button').attr('href', thisLink);
	});


	$('ul.hero-dropdown-jump-menu').on('click', function() {
		$(this).toggleClass('active');
		$(this).parent().toggleClass('active');
		$(this).find('ul').slideToggle();
		$('ul.hero-dropdown-jump-menu')
			.not(this)
			.removeClass('active');

		$('.hero-dropdown-jump-menu.active>li ul').on('mouseleave', function(){
			var jmobj = $('ul.hero-dropdown-jump-menu');
			if (jmobj.length > 0 && jmobj.hasClass('active')) {
				jmobj.toggleClass('active');
				jmobj.parent().toggleClass('active');
				jmobj.find('ul').slideToggle();
			}
		});
	});

}

document.addEventListener('DOMContentLoaded', onDocumentReady);
